/**
 * Utility to disable console logs in production environment.
 * This affects all console logs throughout the application except for errors.
 */

const isDevelopment = import.meta.env.MODE === 'development';

// Disable all console logs in production except errors
if (!isDevelopment) {
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  console.warn = noop;
}

export {};
